<template>
  <div style="width: 100%; height: 100vh; overflow: hiddle">
    <iframe :src="iframeUrl" width="100%" height="100%" frameborder="0"></iframe>
  </div>
</template>

<script>
export default {
    data() {
        return {
            // iframeUrl: "https://work.yingyuchat.com/chatIndex?kefu_id=rnd600&ent_id=5084&lang=cn"
            // iframeUrl: "https://chatbot.weixin.qq.com/webapp/rCpeWiGzFmBQCOFVdmNVZBsbShm5Gl?isFloat=false&robotName=%E5%B9%B3%E5%8F%B0%E5%AE%A2%E6%9C%8D"
            iframeUrl: "https://chatbot.weixin.qq.com/webapp/LDPabBcX8yEAboQGH6JlHGos9xn9dU?isFloat=false&robotName=%E5%92%A8%E8%AF%A2%E5%B9%B3%E5%8F%B0%E5%AE%A2%E6%9C%8D"
        }
    }
}
</script>

<style>

</style>
